<template>
    <div class="land-nav" v-if="salesCard != null" id="landNav">
        <ul class="nav-list">
            <li v-for="(item, index) in salesCard.shablon_main_navigation"  v-if="item.init != 'false'" :key="index">
                <a :href="item.href.value" 
                    v-scroll-to="{
                        el: item.href.value,
                        offset: offsetResponse
                    }" @click="closeMobileMenu">{{item.name}}
                </a>
            </li>
        </ul>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'sale-land-nav',
        components: {
        },
        data () {
            return {
                projectHost: window.host,
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            openSendwich: 'loadOpenSendwich',
            offsetResponse: 'loadOffsetResponse',
        }),
        methods: {
            closeMobileMenu() {
                this.$store.commit('Open_Sendwich', false);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-nav.scss';
    @import '@/styles/components/sales/respond/land-nav-respond.scss';
</style>